import { useTheme } from '@emotion/react';
import AddAPhotoOutlinedIcon from '@mui/icons-material/AddAPhotoOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import { Grid } from '@mui/material';
import AryIconButton from 'framework/desktop/AryIconButton';
import React from 'react';

export default function UploadImageMenu({ handleOpenWebcam }) {
  const theme = useTheme();
  const styles = {
    bgcolor: theme.palette.white.main,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 4,
    height: 'fit-content',
    borderRadius: 1,
    paddingY: 3,
    paddingX: 4,
    position: 'absolute',
    bottom: '-2.5rem',
    right: '.5rem',
    boxShadow: '0px 4px 12px 0px #0000001F'
  };
  return (
    <Grid {...styles}>
      <AryIconButton
        sx={{ padding: 1 }}
        borderRadius={5}
        // sx={{ paddingX: 4, paddingY: 3 }}
        Icon={UploadFileOutlinedIcon}
        iconColor="#005299"
      />
      <AryIconButton
        sx={{ padding: 1 }}
        borderRadius={5}
        // sx={{ paddingX: 4, paddingY: 3 }}
        Icon={AddAPhotoOutlinedIcon}
        iconColor="#005299"
        onClick={(e) => {
          e.stopPropagation();
          handleOpenWebcam(true);
        }}
      />
    </Grid>
  );
}
